import { createStore } from 'redux';


function saveStateToLocal(){
    // localStorage.setItem('user', JSON.stringify(state));


    let user = localStorage.getItem('user');
    user = JSON.parse(user);

    if (user === null || user === ''){
        // return {'loggedIn': false, 'user': user};
        window.location = '#/login';
        return false;
    } else {
        // return {'loggedIn': true, 'user': user};
        return user;
    }


}



const initialState = {
    user: {},
    loggedIn: false
};

function reducer(state = initialState, action) {



    switch(action.type) {
        case 'SET_USER_DATA':
            localStorage.setItem('user', JSON.stringify(action.user));
            return {
                ...state,
                user: action.user,
                loggedIn: true
            };

        default:
            let user = saveStateToLocal();
            if (user === false){
                console.log("logged out for sure");
                return {
                    user: {},
                    loggedIn: false
                }
            } else {
                return {
                    ...state,
                    user: user,
                    loggedIn: true
                }
            }

    }

}




const Store = createStore(
    reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default Store;


// WEBPACK FOOTER //
// ./src/components/Store.js